var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activate-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.9996 2.13672C12.7899 2.13672 15.8625 5.20933 15.8625 8.99958C15.8625 12.7899 12.7899 15.8625 8.9996 15.8625C5.20933 15.8625 2.13672 12.7899 2.13672 8.99958C2.13672 5.20933 5.20933 2.13672 8.9996 2.13672Z",
    stroke: "#121212",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.31407 11.0583L6.94149 9.68571C6.56247 9.30666 6.56247 8.69211 6.94149 8.31306L8.31407 6.94052C8.69312 6.56149 9.3076 6.56149 9.68665 6.94052L11.0592 8.31306C11.4383 8.69211 11.4383 9.30666 11.0592 9.68571L9.68665 11.0583C9.3076 11.4373 8.69312 11.4373 8.31407 11.0583Z",
    stroke: "#121212",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactive);
export default __webpack_public_path__ + "static/media/Reactive.1c4bbd02185cb9c89ba960b14e412daa.svg";
export { ForwardRef as ReactComponent };